import { cn } from "@/lib/utils";

const STEP_NUMBERS = [1, 2, 3, 4] as const;

interface OnboardingProgressProps {
  currentStep: 1 | 2 | 3 | 4;
  title: string;
  description?: string;
}

export function OnboardingProgress({
  currentStep,
  title,
  description,
}: OnboardingProgressProps) {
  return (
    <div className="flex flex-col items-center text-center">
      <h1 className="text-2xl font-semibold tracking-[-0.01em] text-balance">
        {title}
      </h1>
      {description && (
        <p className="mt-2 text-sm text-muted-foreground">{description}</p>
      )}
      <div className="mt-10 mb-4 flex flex-col items-center gap-3">
        <div
          role="progressbar"
          aria-label="Onboarding progress"
          aria-valuemin={1}
          aria-valuemax={STEP_NUMBERS.length}
          aria-valuenow={currentStep}
          className="flex items-center gap-1.5"
        >
          {STEP_NUMBERS.map((stepNumber) => (
            <span
              key={stepNumber}
              className={cn(
                "h-1 w-8 rounded-full transition-colors",
                stepNumber <= currentStep ? "bg-foreground" : "bg-border"
              )}
            />
          ))}
        </div>
        <p className="text-xs font-medium text-muted-foreground">
          Step {currentStep} of {STEP_NUMBERS.length}
        </p>
      </div>
    </div>
  );
}
